import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, DestroyRef, EventEmitter, inject, Input, OnInit, Output } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { LetDirective } from '@directives/app-let.directive';
import { SearchWidgetCopy } from '@models/cms/search-widget.model';
import { GrowthBookFeatureKeys } from '@models/growthbook.models';
import { GrowthBookService } from '@services/growthbook/growthbook.service';

@Component({
  selector: 'app-search-footer',
  standalone: true,
  imports: [
    CommonModule,
    LetDirective,
  ],
  templateUrl: './search-footer.component.html',
  styleUrl: './search-footer.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SearchFooterComponent implements OnInit {
  private destroyRef = inject(DestroyRef);

  @Input() cmsCopy: SearchWidgetCopy;
  @Input() isFlightsPage: boolean | null;
  @Output() cancelClick = new EventEmitter();

  readonly gbf = GrowthBookFeatureKeys;
  
  constructor(
    public gbs: GrowthBookService,
    private cd: ChangeDetectorRef,
  ) { }

  ngOnInit(): void {
    this.initGrowthBookChangeDetection();
  }

  initGrowthBookChangeDetection() {
    this.gbs.onChange$
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(() => {
        this.cd.detectChanges();
      });
  }
}
